module.exports = __webpack_public_path__ + "img/14_pc.6ca434f4.gif";